import { render } from "./GraciasComponent.vue?vue&type=template&id=a93f80c2&scoped=true"
import script from "./GraciasComponent.vue?vue&type=script&lang=js"
export * from "./GraciasComponent.vue?vue&type=script&lang=js"

import "./GraciasComponent.vue?vue&type=style&index=0&id=a93f80c2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a93f80c2"]])

export default __exports__